/* eslint-disable jsx-a11y/accessible-emoji */
import styles from './Topbar.module.css'
import * as moment from 'moment';
import React, { Component } from 'react';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import { LanguageContext } from './../i18n/LanguageContext';

import icMenu from './ic_menu.svg';
import icExit from './ic_exit.svg';

import { ReactSVG } from 'react-svg'
export class Topbar extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);
        this.state = {
            timeComponent: '',
            selectedLanguage: props.selectedLanguage
        };
        this.selectLanguage = this.selectLanguage.bind(this);
        
    }

    componentDidMount() {
        const jwt = JSON.parse(localStorage.getItem('decode'));
        const exp = jwt.exp;
        let counterInterval = setInterval(() => {
            const now = Date.now() / 1000;
            const difference = Math.round(exp - now);
            if (difference <= 0 || !localStorage.getItem('decode')) {
                clearInterval(counterInterval);
                this.props.onExitClick();
            } else {
                const remainigTime = moment().startOf('day').seconds(difference).format('H:mm:ss');
                let timeComponent;
                if (difference >= 300 && difference <= 600) {
                    // Is less than 10 minutes
                    timeComponent = <b className={styles['time-warning']}>{remainigTime}</b>
                } else if (difference >= 0 && difference <= 300) {
                    // Is less than 5 minutes
                    timeComponent = <b className={styles['time-danger']}>{remainigTime}</b>
                } else {
                    timeComponent = <b>{remainigTime}</b>
                }
                this.setState({ timeComponent: timeComponent })
            }
        }, 1000);
    }

    

    selectLanguage(e) {
        const lang = e.target.value;
        this.props.onLanguageChange(lang);
        this.setState({ selectedLanguage: lang});
    }

    render() {
        return <nav className={`navbar navbar-expand-lg navbar-light ${styles['topbar']}`}>
            <div className="col-md-2">
                <span className={styles['topbar-menu-icon']} onClick={this.props.onMenuClick}>
                    <ReactSVG
                        src={icMenu}
                        className={styles['menu-button']} />

                </span>
                <span className={styles['time']}>{this.state.timeComponent}</span>

            </div>
            <div className="col-md-7"></div>
            <div className="col-md-3">
                <div className={styles['topbar-name-wrapper']}>
                    <OverlayTrigger
                        key="bottom"
                        placement="bottom"
                        overlay={<Tooltip>{this.context['LOG_OUT']}</Tooltip>}>
                            <ReactSVG
                                src={icExit}
                                onClick={() => { this.props.onExitClick() }}
                                className={styles['exit-button']} />
                    </OverlayTrigger> 
                    
                    <div>{this.props.user.name} {this.props.user.lastName}</div>
                    <div>
                        <select
                            className={styles['topbar-lang']}
                            value={this.state.selectedLanguage}
                            onChange={this.selectLanguage} >
                            <option value='es'>🇵🇦 {this.context['LANG'] === 'es' ? 'Español' : 'Spanish'}</option>
                            <option value="en">🇺🇸 {this.context['LANG'] === 'es' ? 'Inglés' : 'English'}</option>
                        </select>
                        <p></p>
                    </div>
                </div>
            </div>
        </nav>
    }
}
